import React, { useEffect, useRef, useState } from 'react'
import classes from './CreateFantasyTeam2.module.css'
import { useLocation, useNavigate } from 'react-router-dom'
import { fetchUpcomingMatchDetailsApi, userFantasyTeamApi } from '../../http/http'
import { useDispatch, useSelector } from 'react-redux'
import { FaArrowLeft, FaMinus, FaPlus, FaXmark } from "react-icons/fa6";
import moment from 'moment-timezone'
import { toast } from 'react-toastify'
import SmallLoader from '../../component/SmallLoader'
import { removeUserDetails } from '../../store/slices/userSlice'
import { useTranslation } from 'react-i18next'

const TABS = [
    { key: "goalkeepers", label: "GK", position: "Goalkeeper", max: 1 },
    { key: "defenders", label: "DEF", position: "Defender", max: 4 },
    { key: "midfielders", label: "MID", position: "Midfielder", max: 4 },
    { key: "attackers", label: "ST", position: "Attacker", max: 2 },
];

const TAB_HINTS = {
    goalkeepers: "Pick 1 Goalkeeper",
    defenders: "Pick up to 4 Defenders",
    midfielders: "Pick up to 4 Midfielders",
    attackers: "Pick up to 2 Strikers",
};

const TAB_HINTS_FR = {
    goalkeepers: "Choisissez 1 gardien de but",
    defenders: "Choisissez jusqu'à 4 défenseurs",
    midfielders: "Sélectionnez jusqu'à 4 milieux de terrain",
    attackers: "Choisissez jusqu'à 2 attaquants",
};

const HOW_TO_PLAY = [
    { icon: "⚽", title: "Build Your Squad", desc: "Select 11 players: 1 Goalkeeper, 4 Defenders, 4 Midfielders, and 2 Forwards." },
    { icon: "🎖️", title: "Pick Your Leaders", desc: "Choose 1 Captain and 1 Vice-Captain from your selected players." },
    { icon: "📊", title: "Earn Points", desc: "Players earn points based on their real match performance — goals, assists, clean sheets & more." },
    { icon: "2×", title: "Captain Bonus", desc: "Your Captain receives double (2×) the points earned during the match." },
    { icon: "1.5×", title: "Vice-Captain Bonus", desc: "Your Vice-Captain receives 1.5× the points earned during the match." },
];

const HOW_TO_PLAY_FR = [
    { icon: "⚽", title: "Construisez votre équipe", desc: "Sélectionnez 11 joueurs : 1 gardien de but, 4 défenseurs, 4 milieux de terrain et 2 attaquants." },
    { icon: "🎖️", title: "Choisissez vos leaders", desc: "Choisissez 1 capitaine et 1 vice-capitaine parmi les joueurs sélectionnés." },
    { icon: "📊", title: "Gagnez des points", desc: "Les joueurs gagnent des points en fonction de leurs performances réelles — buts, passes décisives, clean sheets et plus encore." },
    { icon: "2×", title: "Bonus du capitaine", desc: "Votre capitaine reçoit le double (2×) des points gagnés pendant le match." },
    { icon: "1.5×", title: "Bonus du vice-capitaine", desc: "Votre vice-capitaine reçoit 1,5× les points gagnés pendant le match." },
];

const CreateFantasyTeam2 = () => {
    const location = useLocation();
    const [matchDetails, setMatchDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { userDetails } = useSelector((state) => state.persisted.userSlice);
    const [position, setPosition] = useState("goalkeepers");
    const [players, setPlayers] = useState(null);
    const [selectedPlayers, setSelectedPlayers] = useState([]);
    const [loader, setLoader] = useState(true);
    const [time, setTime] = useState(null);
    const [playModal, setPlayModal] = useState(false);
    const dispatch = useDispatch();

    const { selectedLanguage } = useSelector((state) => state.languageSlice);

    const { t } = useTranslation();

    const matchTimer = (match_date_time) => {
        try {
            const liveTime = moment();
            const matchTime = moment.utc(match_date_time);
            const timeLeft = moment.duration(matchTime.diff(liveTime));

            if (timeLeft.asMilliseconds() <= 0) {
                console.log("Match has already started.");
                navigate("/home");
                toast.info(t("57"));
            }
            const hours = Math.floor(timeLeft.asHours());
            const minutes = timeLeft.minutes();
            const seconds = timeLeft.seconds();

            console.log(`Match starts in ${hours}h ${minutes}m ${seconds}s`);
            setTime(`${hours}h ${minutes}m ${seconds}s`);
        } catch (error) {
            console.log(error, 'errro--');
        }
    }

    useEffect(() => {
        if (matchDetails) {
            const intervalId = setInterval(() => {
                matchTimer(matchDetails?.match_date_time);
            }, 1000);
            return () => clearInterval(intervalId);
        }
    }, [matchDetails]);

    const fetchMatchDetails = async (match_fixture_id, load) => {
        try {
            if (load) setLoading(true);
            setLoader(true);
            const response = await fetchUpcomingMatchDetailsApi(match_fixture_id, userDetails?.token);
            console.log(response, 'match details response');
            setMatchDetails(response?.data);
            setPlayers(() => ({
                homeTeam: JSON.parse(response?.data?.home_team_players),
                awayTeam: JSON.parse(response?.data?.away_team_players)
            }));
            setLoading(false);
            setLoader(false);
        } catch (error) {
            if (error?.response?.status == 403) {
                dispatch(removeUserDetails());
                toast.error(t("48"));
                navigate('/');
            } else {
                setLoading(false);
                setLoader(false);
                toast.error(t("20"));
            }
        }
    }

    const fetchUserTeam = async (match_fixture_id) => {
        try {
            setLoading(true);
            const response = await userFantasyTeamApi(match_fixture_id, userDetails?.token);
            console.log(response, 'user team,');
            setSelectedPlayers(JSON.parse(response?.data?.team));
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log(error, 'error===');
        }
    }

    useEffect(() => {
        if (location?.state?.match_fixture_id) {
            fetchMatchDetails(location?.state?.match_fixture_id, true);
            if (location?.state?.edit) {
                fetchUserTeam(location?.state?.match_fixture_id);
            }
        } else {
            navigate("/home");
        }
    }, [location?.state?.match_fixture_id]);

    useEffect(() => {
        if (!loader && location?.state?.match_fixture_id) {
            const intervalId = setInterval(() => {
                if (!document.hidden) {
                    fetchMatchDetails(location?.state?.match_fixture_id, false);
                }
            }, 10000);
            return () => clearInterval(intervalId);
        }
    }, [loader, location?.state?.match_fixture_id]);

    const handleSelectPlayer = async (item, teamId, teamName) => {
        try {
            let count = selectedPlayers.filter(data => data.position == item.position).length;
            let max = item?.position == "Goalkeeper" ? 1 : item?.position == "Defender" ? 4 : item?.position == "Midfielder" ? 4 : 2;
            if (selectedPlayers.find((data) => data.id === item.id)) {
                setSelectedPlayers((prevValue) => prevValue.filter((data) => data.id !== item.id));
            } else if (count >= max) {
                toast.info("You can only select" + " " + max + " " + item?.position);
            } else {
                setSelectedPlayers((prevValue) => [
                    ...prevValue,
                    { ...item, teamId, teamName, captain: false, viceCaptain: false },
                ]);
            }
        } catch (error) {
            console.log(error, 'error...');
        }
    }

    const totalSelected = selectedPlayers.length;
    const canProceed = totalSelected >= 11;

    return (
        <div className={classes.page}>
            {loading ? (
                <div className={classes.pageInner}>
                    <div className={classes.loaderWrap}>
                        <SmallLoader />
                        <p className={classes.loaderText}>{t("58")}</p>
                    </div>
                </div>
            ) : (
                <div className={classes.pageInner}>

                    {/* ── Sticky header ── */}
                    <div className={classes.stickyHeader}>

                        {/* Top bar */}
                        <div className={classes.topBar}>
                            <button type="button" className={classes.backBtn} onClick={() => navigate("/home")}>
                                <FaArrowLeft className={classes.backIcon} />
                            </button>

                            <div className={classes.topBarCenter}>
                                <span className={classes.pageTitle}>
                                    {location?.state?.edit ? t("59") : t("60")} {t("61")}
                                </span>
                                {time && (
                                    <span className={classes.timerPill}>
                                        <span className={classes.timerDot} />
                                        {time} {t("62")}
                                    </span>
                                )}
                            </div>

                            <button type="button" className={classes.howToBtn} onClick={() => setPlayModal(true)}>
                                {t("63")}
                            </button>
                        </div>

                        {/* Match strip */}
                        <div className={classes.matchStrip}>
                            <div className={classes.teamSide}>
                                <img src={matchDetails?.home_team_image} alt={matchDetails?.home_team_name} className={classes.teamLogo} />
                                <span className={classes.teamName}>{matchDetails?.home_team_name}</span>
                                <span className={classes.playerCountBadge}>
                                    {selectedPlayers?.filter(d => d?.teamId == matchDetails?.home_team_id).length}
                                </span>
                            </div>

                            <div className={classes.vsBlock}>
                                <span className={classes.vsText}>VS</span>
                                <span className={classes.totalCount}>{totalSelected}/11</span>
                            </div>

                            <div className={classes.teamSide}>
                                <span className={classes.playerCountBadge}>
                                    {selectedPlayers?.filter(d => d?.teamId == matchDetails?.away_team_id).length}
                                </span>
                                <span className={classes.teamName}>{matchDetails?.away_team_name}</span>
                                <img src={matchDetails?.away_team_image} alt={matchDetails?.away_team_name} className={classes.teamLogo} />
                            </div>
                        </div>

                        {/* Progress bar */}
                        <div className={classes.progressBar}>
                            <div
                                className={classes.progressFill}
                                style={{ width: `${(totalSelected / 11) * 100}%` }}
                            />
                        </div>

                        {/* Position tabs */}
                        <div className={classes.tabsRow}>
                            {TABS.map(({ key, label, position: pos }) => {
                                const count = selectedPlayers.filter(d => d?.position === pos).length;
                                return (
                                    <button
                                        key={key}
                                        type="button"
                                        className={`${classes.tab} ${position === key ? classes.tabActive : ''}`}
                                        onClick={() => setPosition(key)}
                                    >
                                        {label}
                                        {count > 0 && <span className={classes.tabCount}>{count}</span>}
                                    </button>
                                );
                            })}
                        </div>

                        {/* Hint bar */}
                        <div className={classes.hintBar}>
                            <span className={classes.hintText}>
                                {/* {TAB_HINTS[position]} */}
                                {selectedLanguage==0?TAB_HINTS[position]:TAB_HINTS_FR[position]}
                                </span>
                        </div>
                    </div>

                    {/* ── Player list ── */}
                    <div className={classes.playersList}>
                        {players?.homeTeam?.[position]?.length > 0 && (
                            <div className={classes.teamDivider}>
                                <span className={classes.teamDividerText}>{players?.homeTeam?.teamName}</span>
                            </div>
                        )}
                        {players?.homeTeam?.[position]?.map((item, index) => {
                            const selected = selectedPlayers.find(d => d.id === item.id);
                            return (
                                <button
                                    key={index}
                                    type="button"
                                    className={`${classes.playerRow} ${selected ? classes.playerRowSelected : ''}`}
                                    onClick={() => handleSelectPlayer(item, players?.homeTeam?.teamId, players?.homeTeam?.teamName)}
                                >
                                    <div className={classes.playerLeft}>
                                        <div className={`${classes.playerImgWrap} ${selected ? classes.playerImgWrapSelected : ''}`}>
                                            <img src={item?.photo} alt={item?.name} className={classes.playerImg} />
                                        </div>
                                        <div className={classes.playerInfo}>
                                            <span className={classes.playerName}>{item?.name}</span>
                                            <span className={classes.playerTeam}>{players?.homeTeam?.teamName}</span>
                                        </div>
                                    </div>
                                    <div className={`${classes.actionBtn} ${selected ? classes.actionBtnRemove : classes.actionBtnAdd}`}>
                                        {selected
                                            ? <FaMinus className={classes.actionIcon} />
                                            : <FaPlus className={classes.actionIcon} />
                                        }
                                    </div>
                                </button>
                            );
                        })}

                        {players?.awayTeam?.[position]?.length > 0 && (
                            <div className={classes.teamDivider}>
                                <span className={classes.teamDividerText}>{players?.awayTeam?.teamName}</span>
                            </div>
                        )}
                        {players?.awayTeam?.[position]?.map((item, index) => {
                            const selected = selectedPlayers.find(d => d.id === item.id);
                            return (
                                <button
                                    key={index}
                                    type="button"
                                    className={`${classes.playerRow} ${selected ? classes.playerRowSelected : ''}`}
                                    onClick={() => handleSelectPlayer(item, players?.awayTeam?.teamId, players?.awayTeam?.teamName)}
                                >
                                    <div className={classes.playerLeft}>
                                        <div className={`${classes.playerImgWrap} ${selected ? classes.playerImgWrapSelected : ''}`}>
                                            <img src={item?.photo} alt={item?.name} className={classes.playerImg} />
                                        </div>
                                        <div className={classes.playerInfo}>
                                            <span className={classes.playerName}>{item?.name}</span>
                                            <span className={classes.playerTeam}>{players?.awayTeam?.teamName}</span>
                                        </div>
                                    </div>
                                    <div className={`${classes.actionBtn} ${selected ? classes.actionBtnRemove : classes.actionBtnAdd}`}>
                                        {selected
                                            ? <FaMinus className={classes.actionIcon} />
                                            : <FaPlus className={classes.actionIcon} />
                                        }
                                    </div>
                                </button>
                            );
                        })}

                        <div style={{ height: 96 }} />
                    </div>

                    {/* ── Sticky Next button ── */}
                    <div className={classes.nextWrap}>
                        <div className={classes.nextInner}>
                            <span className={classes.nextCount}>
                                {totalSelected}/11 {t("64")}
                            </span>
                            <button
                                type="button"
                                disabled={!canProceed}
                                className={`${classes.nextBtn} ${canProceed ? classes.nextBtnActive : ''}`}
                                onClick={() => {
                                    if (canProceed) {
                                        navigate("/select-captains", {
                                            state: {
                                                selectedPlayers,
                                                matchDetails,
                                                edit: location?.state?.edit
                                            }
                                        });
                                    }
                                }}
                            >
                                {t("65")}
                            </button>
                        </div>
                    </div>

                    {/* ── How To Play Modal ── */}
                    {playModal && (
                        <div className={classes.modalOverlay} onClick={() => setPlayModal(false)}>
                            <div className={classes.modalSheet} onClick={(e) => e.stopPropagation()}>

                                {/* Modal header */}
                                <div className={classes.modalHeader}>
                                    <div className={classes.modalHeaderLeft}>
                                        <span className={classes.modalEyebrow}>{t("66")}</span>
                                        <h2 className={classes.modalTitle}>{t("67")}</h2>
                                    </div>
                                    <button
                                        type="button"
                                        className={classes.modalCloseBtn}
                                        onClick={() => setPlayModal(false)}
                                    >
                                        <FaXmark className={classes.modalCloseIcon} />
                                    </button>
                                </div>

                                {/* Steps */}
                                <div className={classes.modalBody}>
                                    {
                                    selectedLanguage==0?
                                    HOW_TO_PLAY.map((step, i) => (
                                        <div key={i} className={classes.stepRow}>
                                            <div className={classes.stepIconWrap}>
                                                <span className={classes.stepIcon}>{step.icon}</span>
                                                {i < HOW_TO_PLAY.length - 1 && (
                                                    <div className={classes.stepLine} />
                                                )}
                                            </div>
                                            <div className={classes.stepContent}>
                                                <span className={classes.stepTitle}>{step.title}</span>
                                                <span className={classes.stepDesc}>{step.desc}</span>
                                            </div>
                                        </div>
                                    ))
                                :
                                   HOW_TO_PLAY_FR.map((step, i) => (
                                        <div key={i} className={classes.stepRow}>
                                            <div className={classes.stepIconWrap}>
                                                <span className={classes.stepIcon}>{step.icon}</span>
                                                {i < HOW_TO_PLAY_FR.length - 1 && (
                                                    <div className={classes.stepLine} />
                                                )}
                                            </div>
                                            <div className={classes.stepContent}>
                                                <span className={classes.stepTitle}>{step.title}</span>
                                                <span className={classes.stepDesc}>{step.desc}</span>
                                            </div>
                                        </div>
                                    ))
                                }
                                </div>

                                {/* Footer CTA */}
                                <div className={classes.modalFooter}>
                                    <button
                                        type="button"
                                        className={classes.modalGotItBtn}
                                        onClick={() => setPlayModal(false)}
                                    >
                                        {t("68")}
                                    </button>
                                </div>

                            </div>
                        </div>
                    )}

                </div>
            )}
        </div>
    );
}

export default CreateFantasyTeam2;